import { Analytics } from 'packages';

export const getMenuGaAttributes = (category, action, label) => ({
    'data-ga-category': category,
    'data-ga-action': action,
    'data-ga-label': `Link - ${label}`
});

export const trackProfileClick = (isLoggedIn, open) => {
    Analytics.trackEvent({
        category: 'Top navigation',
        action: `${isLoggedIn ? 'Account' : 'Login'} menu`,
        label: `${open ? 'Menu open' : 'Menu close'}`
    });
};
